import  { useEffect, useRef } from 'react';
import {  ref, onValue,  } from 'firebase/database';
import { useNotification } from '../context/NotificationContext';
import useAuth from '../hooks/useAuth';
import { database } from '../config/firebaseConfig';

const ChatNotificationListener = () => {
  const { user } = useAuth();
  const { showNotification } = useNotification();
  const lastMessageRef = useRef({});

  useEffect(() => {
    if (!user) return;

    const chatsRef = ref(database, 'chats');

    const unsubscribe = onValue(chatsRef, (snapshot) => {
      const chatsData = snapshot.val();
      if (!chatsData) return;

      Object.entries(chatsData).forEach(([chatRoomId, chatRoomData]) => {
        if (chatRoomId.includes(`${user.first_name}_${user.last_name || ''}`) || 
            chatRoomId.includes(`${user.first_name}_`)) {
          const messages = chatRoomData.messages || {};
          Object.entries(messages).forEach(([messageId, message]) => {
            if (message.senderId !== user.first_name) {
              const notificationKey = `${chatRoomId}_${messageId}`;
              if (!lastMessageRef.current[notificationKey]) {
                showNotification(
                  `New message from ${message.senderName}: ${message.text}`,
                  "info"
                );
                lastMessageRef.current[notificationKey] = true;
              }
            }
          });
        }
      });
    });

    return () => unsubscribe();
  }, [user, showNotification]);

  return null;
};

export default ChatNotificationListener;
